import { createViewContext } from "../../Components/createViewContext"
import { useContext } from "react"
import { AppRoute, RouterNavigateFunction } from "../../App/Routes"
import { UseOverlayResetValue, UseOverlaySetValue } from "../../App/useOverlay"
import { PrintMode, PrintRoot } from "../PrintView"
import { ShipViewOverlayContent, ShipViewOverlayOptions } from "./OverlayContentView"
import { IShipUser } from "../../Types"

export interface ShipViewState {
  navigateShip: RouterNavigateFunction;
  shipCloudEditable: boolean;
  shipOverlay: ShipViewOverlayContent;
  shipOverlayOptions: ShipViewOverlayOptions;
  resetShipOverlay: UseOverlayResetValue;
  setShipOverlay: UseOverlaySetValue<ShipViewOverlayContent, ShipViewOverlayOptions>;
  printMode: PrintMode;
  printRoot?: PrintRoot;
  printTripId?: number;
  printDayId?: number;
  setPrinting: (mode: PrintMode, object?: PrintRoot, tripId?: number, dayId?: number) => void;
  shipRoute: AppRoute;
  shipRouteName: string;
  focusActive: boolean;
  shipUsers?: IShipUser[];
  // The ShipUser new attributed entries (log/note) are written as, when it differs
  // from the real, authenticated ShipUser -- see UserSwitchView (#197/#1026 (tracker #827)). Owned
  // by AppView.tsx (not this context) since MenuAccount, which triggers the picker, sits
  // outside ShipViewContext's subtree; ShipView re-exposes it here for the overlay's own
  // picker UI and passes it back up unchanged.
  actingShipUser?: IShipUser;
  setActingShipUser: (user?: IShipUser) => void;
}

const shipViewContext = createViewContext<ShipViewState>();
export const ShipViewContext = shipViewContext.Context;
export const GetShipView = shipViewContext.useGet;

// The open ship's crew is scoped to the ShipView subtree. Consumers read it through this
// hook rather than the app-global ShipContext: inside ShipView it returns the loaded crew
// (undefined while still loading); outside ShipView (e.g. the new-ship editor rendered at
// the AppView level) there is no ship, so it returns an empty array.
export const GetShipUsers = (): IShipUser[] | undefined => {
  const ctx = useContext(ShipViewContext);
  return ctx ? ctx.shipUsers : [];
};
